import React from "react";
import ReactDOM from "react-dom";
import { logError, addContextLog } from "../../infrastructure/log";
import { showErrorMessage } from "../commons/show-error-message";
import { translate } from "../../infrastructure/translate/localization";
import ApproveRequestHHRR from "../../app/components/modals/requests/ApproveRequestHHRR";
import { findCompanyId } from "../../infrastructure/repository/company-repository";
import { getEmployeeBenefitBag } from "../../infrastructure/repository/benefit-models-repository";

function renderApproveRequestHHRRModal(props) {
  const target = document.getElementById("table-request-education-container");

  if (target) {
    ReactDOM.render(
      <ApproveRequestHHRR {...props} />,
      document.getElementById("modal-container")
    );
  }
}

export async function displayApproveRequestHHRRRequest(
  requestId,
  amount,
  employeeId
) {
  try {
    const companyId = await findCompanyId();
    const { data: benefitBags } = await getEmployeeBenefitBag({
      companyId,
      employeeId,
    });
    const educationBags = benefitBags?.filter(({ allowedFor }) =>
      allowedFor.includes("education-benefit")
    );

    renderApproveRequestHHRRModal({ requestId, amount, educationBags });
    addContextLog(
      "info",
      "displayApproveRequestHHRRRequest",
      "display-screen",
      {
        requestId,
        amount,
      }
    );
  } catch (e) {
    logError(
      e,
      `Error to displayApproveRequestHHRRRequest in request ${requestId}`
    );
    showErrorMessage(translate("common-messages.basic-error-message"), true);
  }
}
